module.exports = __webpack_public_path__ + "media/images/workplace/login-bg-688e47bb9c39128ec3b12673ff3ce245.png";